<template>
  <div class="portada-xv" ref="rootRef" aria-label="Portada de XV">
    <!-- FLORES DECORATIVAS -->
    <img src="@/assets/fn.png" class="flor flor-1" alt="" />
    <img src="@/assets/fn.png" class="flor flor-2" alt="" />
    <img src="@/assets/fn.png" class="flor flor-3" alt="" />

    <!-- NUEVAS FLORES -->
    <img src="@/assets/flor1.png" class="flor flor-4" alt="" />
    <img src="@/assets/fn.png" class="flor flor-5" alt="" />
    <img src="@/assets/flor3.png" class="flor flor-6" alt="" />

    <!-- BOLA DISCO GIRANDO -->
    <img src="@/assets/disco.png" class="bola bola-izquierda" alt="" />

    <!-- IMAGEN CON RECORTE -->
    <div class="imagen-xv-wrapper">
      <img src="@/assets/DSC00846 (1).webp" class="imagen-xv" alt="Foto protagonista" />
    </div>

    <!-- TEXTO PRINCIPAL -->
    <section class="texto-xv">
      <p class="frase-bendicion">
        Con la bendición de Dios <br />
        y de mi Familia:
      </p>
<br />
<h1 class="nombre-protagonista">
  Brenda <span class="ampersand-padres">&</span> Manuel Serrano
</h1>      
      <div class="ampersand-padres"></div>

      <h1 class="nombre-protagonista">  </h1>

      <!-- 🔥 SECCIÓN DEL PADRE CON NOMBRE ABAJO -->
      <div class="contenedor-padre">
        <span class="etiqueta-padre">Mi padre:</span>
        <h2 class="nombre-padre">
          Jesús A. Sánchez <i class="fas fa-cross cross-icon" aria-hidden="true"></i>
        </h2>
      </div>

      <div class="separador-elegante" aria-hidden="true"></div>

      <p class="parrafo-presentacion">
        <br>
        Gracias a mis padres, quien con amor, esfuerzo y ejemplo han guiado cada uno de mis pasos.
        Hoy me llena de felicidad compartir este momento tan especial con las personas que forman
        parte de mi vida y de mi corazón.
      </p>
      <p class="salmo-ref"></p>
    </section>
  </div>
</template>

<script>
import { onMounted, ref, nextTick } from 'vue'
import gsap from 'gsap'

export default {
  name: 'PortadaArley',
  setup() {
    const rootRef = ref(null)

    onMounted(async () => {
      await nextTick()

      const $ = (sel) => Array.from(gsap.utils.toArray(sel)).filter(Boolean)

      const foto = $('.imagen-xv-wrapper')

      const flores = [
        '.flor-1',
        '.flor-2',
        '.flor-3',
        '.flor-4',
        '.flor-5',
        '.flor-6'
      ].flatMap($)

      /* 🔥 ORDEN EXCLUSIVO Y CONSECUTIVO DE GSAP */
      const texto = [
        '.frase-bendicion',                          // Con la bendición...
        '.nombre-protagonista:not(.padrino-nombre)', // Nombres iniciales
        '.ampersand-padres',                         // Ampersand
        '.etiqueta-padre',                           // 👈 CONSECUTIVO: "Mi padre:"
        '.nombre-padre',                             // 👈 CONSECUTIVO: "Jesús A. Sánchez †"
        '.separador-elegante',                       // Separador
        '.padrinos-label',                           // Mis padrinos
        '.padrino-nombre',                           // Briza y Osvaldo
        '.parrafo-presentacion',
        '.salmo-ref'                                 // Salmo
      ].flatMap($)

      gsap.set([...foto, ...flores, ...texto], { autoAlpha: 0, y: 28 })

      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (!e.isIntersecting) return

          const tl = gsap.timeline({ defaults: { ease: 'power2.out' } })

          tl.fromTo(
            foto,
            { scale: 0.94, y: 40, filter: 'blur(6px)' },
            { autoAlpha: 1, scale: 1, y: 0, filter: 'blur(0px)', duration: 1.15 }
          )

          tl.to(
            flores,
            {
              autoAlpha: 1,
              y: 0,
              rotate: () => gsap.utils.random(-8, 6),
              duration: 0.9,
              stagger: 0.12
            },
            '-=0.6'
          )

          /* 🔥 ANIMACIÓN CON STAGGER PARA PASO A PASO CONSECUTIVO */
          tl.to(
            texto,
            {
              autoAlpha: 1,
              y: 0,
              duration: 0.8,
              stagger: 0.18
            },
            '-=0.3'
          )

          flores.forEach((flor, i) => {
            gsap.to(flor, {
              y: `+=${gsap.utils.random(6, 14)}`,
              x: `+=${gsap.utils.random(-6, 6)}`,
              rotation: gsap.utils.random(-0.8, 0.8),
              duration: gsap.utils.random(2.8, 4),
              repeat: -1,
              yoyo: true,
              ease: 'sine.inOut',
              delay: i * 0.2
            })
          })

          gsap.to(foto, {
            scale: 1.015,
            duration: 3.5,
            yoyo: true,
            repeat: -1,
            ease: 'sine.inOut'
          })

          io.disconnect()
        })
      }, { threshold: 0.45 })

      if (rootRef.value) io.observe(rootRef.value)
    })

    return { rootRef }
  }
}
</script>

<style scoped>
.padrinos-label{
  font-family: "Playfair Display", serif;
  font-size: clamp(18px, 2.6vw, 24px);
  color:#2f2e2e;
  margin-top: 12px;
}

.padrino-nombre{
  font-family: "titulos", cursive;
  font-size: 40px;
  color:#d34980;
  margin: 4px 0;
}
</style>


<style scoped>
/* TODO TU CSS ORIGINAL SE MANTIENE */

.flor-4{
  top: 50px;
  left: 15px;
  transform: translateX(-50%) rotate(-12deg);

  width: min(30vw, 110px) !important;
  z-index: 6;
}
.flor-5{
  bottom: 20px;
  transform: translateX(-50%) rotate(-12deg);
  opacity: 0 !important;

  right: -50px !important;
  width: min(46vw, 240px);
  z-index: 8;
}
.flor-6{
  top: 420px;
  transform: translateX(-50%) rotate(-12deg);
  right: -90px;
  width: min(30vw, 110px) !important;
  z-index: 3;
}
</style>


<style scoped>

.portada-xv{
  position:relative;
  width:100%;
  min-height:100vh;
  overflow:visible;
  display:flex;
  margin-top:-50px;
  flex-direction:column;
  align-items:center;
  justify-content:flex-start;
  padding:0px 16px 56px;
}
.portada-xv::before{
  content: "";
  position: fixed; /* 🔥 efecto fixed real en móvil */
  inset: 0;

  background: 
    linear-gradient(rgba(255, 255, 255, 0.655), rgba(255, 255, 255, 0.363)),
    url('@/assets/2354d5709722bc255d544d8794809282.jpg');  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  z-index: -1; /* detrás de todo */

  /* opcional: efecto elegante */
  transform: scale(1.05);
}

/* Marco con recorte superior redondeado (look luxury) */
.imagen-xv-wrapper{
  width: min(92vw, 360px);
  height: calc(min(92vw, 360px) * 1.5);
  margin-top: 55px;
  border-radius: 180px 180px 0 0;
  overflow: hidden;
  z-index: 2;
  background:#fff;
  box-shadow:
    0 12px 40px rgba(0,0,0,.18),
    0 2px 8px rgba(0,0,0,.06);
  will-change: transform, filter, opacity;
}
.imagen-xv{
  width:100%;
  height:100%;
  object-fit:cover;
  display:block;
}

/* Texto */
.texto-xv{
  max-width: 620px;
  text-align:center;
  margin-top: 22px;
  padding: 0 8px;
}
.frase-bendicion{
  font-family: "Playfair Display", serif;
  font-size: clamp(18px, 2.6vw, 24px);
  color:#2f2e2e;
  line-height:1.5;
  margin: 20px 0 10px;
}
.separador-elegante{
  width:110px;
  height:2px;
  margin:12px auto 16px;
  background: linear-gradient(90deg, transparent, #d9b7c6, transparent);
  border-radius: 2px;
}
.nombre-protagonista{
 font-family: "Playfair Display", serif; /* 👈 Fuente distinta a la de los novios */
  font-size: clamp(22px, 3vw, 28px);
  font-weight: 600;
  color: #d34980;
  margin: 4px 0 0 0;
  line-height: 1.2;
}

/* 🔥 ESTILOS NUEVOS PARA EL NOMBRE DEL PADRE */
.nombre-padre {
  font-family: "titulos", cursive;
  font-size: 38px;
  color: #d34980;
  margin: 14px 0 8px 0;
  line-height: 1.2;
}
.cross-icon {
  font-size: 18px;
  color: #888;
  vertical-align: middle;
  margin-left: 6px;
}
/* 🔥 ESTILOS CON FUENTE DIFERENTE */
.seccion-padre {
  margin: 20px 0 10px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.etiqueta-padre {
  font-family: "Playfair Display", serif;
  font-size: clamp(19px, 2vw, 21px);
  color: #2f2e2e;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.nombre-padre {
  font-family: "Playfair Display", serif; /* 👈 Fuente distinta a la de los novios */
  font-size: clamp(22px, 3vw, 28px);
  font-weight: 600;
  color: #d34980;
  margin: 4px 0 0 0;
  line-height: 1.2;
}

.cross-icon {
  font-size: 16px;
  color: #d34980;
  vertical-align: middle;
  margin-left: 6px;
}
.parrafo-presentacion{
  font-family: "quote", sans-serif;
  font-size: clamp(18px, 2.6vw, 19px);
  color:#3d3c3c;
  line-height:1.7;
  margin-top: 6px;
}

/* FLORES */
.flor{
  position:absolute;
  width:min(44vw, 180px);
  z-index:10;
  transform-origin:center;
  will-change: transform, opacity;
}
.flor-1{ top:30px; left:-5px !important; z-index:5; width:min(40vw, 120px) !important; opacity: 0 !important; }
.flor-2{ top:45px !important; right:-5px !important; transform: rotate(-80deg);opacity: 0 !important; z-index:1; width:min(40vw, 120px) !important;  }
.flor-3{ bottom:-80px; left:-60px !important; transform: rotate(-30deg); z-index:9;}

/* 🔥 AMPERSAND PADRES */
.ampersand-padres{
  font-family: 'Montserrat', sans-serif;
  font-size: 22px;
  color:#d34980;
  line-height:1;
  margin: 4px 0 12px;
  opacity:.75;
}

/* BOLA DISCO */
.bola{
  position:absolute;
  width:120px;
  animation: girar 10s linear infinite;
  opacity:.85;
  z-index:1;
  opacity:0 !important;
  will-change: transform;
}
.bola-izquierda{ left:-20px; bottom:-50px; z-index:9;}
@keyframes girar{ from{transform:rotate(0)} to{transform:rotate(360deg)} }

/* Responsive refinado */
@media (min-width: 992px){
  .portada-xv{ padding-top:64px; }
  .imagen-xv-wrapper{ margin-top: 0; }
}

.salmo-ref{
  display: block;
  text-align: right; /* 👈 lo manda a la derecha */
  margin-top: 6px;

  font-size: 13px;
  color: #888; /* más elegante */
  font-family: 'Montserrat', sans-serif;

  opacity: 0.8;
}
</style>

```